/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import {
  setCourseCategories,
  addCourses,
  setCourseSearchTerm,
  setSearchResults,
  setSelectedCourseCategory,
  setFetchingCourses,
} from './actions';
import { CourseCategoryModel, CourseModel } from './models';

export interface MarketplaceState {
  searchResults: string[];

  courses: {
    [key: CourseModel['id']]: CourseModel;
  };
  categories: {
    [key: CourseCategoryModel['id']]: CourseCategoryModel;
  };
  selectedCategory: CourseCategoryModel['id'] | undefined;
  searchTerm: string;
  fetchingCourses: boolean;
}

const initialState: MarketplaceState = {
  searchResults: [],
  courses: {},
  categories: {},
  selectedCategory: undefined,
  searchTerm: '',
  fetchingCourses: false,
};

const reduceCourses = (
  acc: MarketplaceState['courses'],
  course: CourseModel,
) => {
  acc[course.id] = course;
  return acc;
};

// eslint-disable-next-line import/prefer-default-export, @typescript-eslint/no-empty-function
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(setFetchingCourses, (state, action) => {
    state.fetchingCourses = action.payload;
  });

  builder.addCase(setSearchResults, (state, action) => {
    state.courses = action.payload.reduce(reduceCourses, state.courses);
    state.searchResults = action.payload.map((course) => course.id);
  });

  builder.addCase(addCourses, (state, action) => {
    state.courses = action.payload.reduce(reduceCourses, state.courses);
  });

  builder.addCase(setCourseCategories, (state, action) => {
    state.categories = action.payload.reduce((acc, cat) => {
      acc[cat.id] = cat;
      return acc;
    }, state.categories);
  });

  builder.addCase(setSelectedCourseCategory, (state, action) => {
    state.selectedCategory = action.payload;
  });

  builder.addCase(setCourseSearchTerm, (state, action) => {
    state.searchTerm = action.payload;
  });
});
